import { useEffect, useState } from 'react';
import api from '../api';

function StockHistory() {
  const [daysData, setDaysData] = useState([]);
  const [days, setDays] = useState(10);
  const [selectedDate, setSelectedDate] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [search, setSearch] = useState('');
  const [type, setType] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchHistory = async () => {
    try {
      setLoading(true);
      setError('');

      const params = {
        days: selectedDate ? undefined : days,
        dateFrom: selectedDate ? selectedDate : dateFrom || undefined,
        dateTo: selectedDate ? selectedDate : dateTo || undefined,
        search: search || undefined,
        type: type
      };

      const response = await api.get('/getStockHistory', { params });
      setDaysData(response.data.days || []);
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'Nu am putut incarca istoricul de marfa'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const clearExactDate = () => {
    setSelectedDate('');
  };


  const handleDeleteEntry = async (entryIndex) => {
    const ok = window.confirm('Sigur vrei sa stergi aceasta inregistrare?');
    if (!ok) return;

    try {
      setError('');
      await api.delete('/stockLog/' + entryIndex);
      await fetchHistory();
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'Nu am putut sterge inregistrarea'
      );
    }
  };
  return (
    <div style={pageStyle}>
      <h1 style={titleStyle}>Istoric marfa</h1>
      <p style={subtitleStyle}>
        Aici vezi intrarile de marfa, retururile si neridicatele, grupate pe zile.
        Poti filtra pe interval sau pe o zi exacta.
      </p>

      <div style={cardStyle}>
        <div style={filtersGridStyle}>
          <div>
            <label style={labelStyle}>Zi exacta</label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Ultimele X zile</label>
            <select
              value={days}
              onChange={(e) => setDays(Number(e.target.value))}
              style={inputStyle}
              disabled={!!selectedDate}
            >
              <option value={5}>5 zile</option>
              <option value={10}>10 zile</option>
              <option value={20}>20 zile</option>
              <option value={30}>30 zile</option>
              <option value={60}>60 zile</option>
            </select>
          </div>

          <div>
            <label style={labelStyle}>Data de la</label>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              style={inputStyle}
              disabled={!!selectedDate}
            />
          </div>

          <div>
            <label style={labelStyle}>Data pana la</label>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              style={inputStyle}
              disabled={!!selectedDate}
            />
          </div>

          <div>
            <label style={labelStyle}>Tip</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={inputStyle}
            >
              <option value="all">Toate</option>
              <option value="purchase">Doar intrare marfa</option>
              <option value="return">Doar retur</option>
              <option value="unclaimed">Doar neridicate</option>
            </select>
          </div>

          <div>
            <label style={labelStyle}>Cautare</label>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Nume / cod / cod de bare"
              style={inputStyle}
            />
          </div>

          <div style={buttonGroupStyle}>
            <button onClick={fetchHistory} style={buttonStyle}>
              Filtreaza
            </button>

            <button onClick={clearExactDate} style={secondaryButtonStyle}>
              Goleste ziua exacta
            </button>
          </div>
        </div>
      </div>

      {selectedDate ? (
        <div style={infoStyle}>
          Afisezi doar istoricul din data de {formatDateOnly(selectedDate)}.
        </div>
      ) : null}

      {loading ? <div style={infoStyle}>Se incarca istoricul de marfa...</div> : null}
      {error ? <div style={errorStyle}>{error}</div> : null}

      {daysData.length === 0 && !loading ? (
        <div style={cardStyle}>Nu exista intrari de marfa pentru filtrele selectate.</div>
      ) : null}

      {daysData.map((dayItem) => (
        <div key={dayItem.day} style={cardStyle}>
          <h2 style={sectionTitleStyle}>
            {dayItem.day}  Total bucati: {dayItem.totalQuantity}
          </h2>

          <div style={tableWrapStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Ora</th>
                  <th style={thStyle}>Cod produs</th>
                  <th style={thStyle}>Nume produs</th>
                  <th style={thStyle}>Cod de bare</th>
                  <th style={thStyle}>Cantitate</th>
                  <th style={thStyle}>Tip</th>
                    <th style={thStyle}>Actiuni</th>
                </tr>
              </thead>
              <tbody>
                {dayItem.entries.map((entry, index) => (
                  <tr key={dayItem.day + '-' + entry.id + '-' + entry.date + '-' + index}>
                    <td style={tdStyle}>{formatTime(entry.date)}</td>
                    <td style={tdStyle}>{entry.id}</td>
                    <td style={tdStyle}>{entry.productName}</td>
                    <td style={tdStyle}>{entry.barcode || '-'}</td>
                    <td style={tdStyle}>{entry.quantity}</td>
                    <td style={tdStyle}>
                      <span style={getTypeBadgeStyle(entry.type)}>
                        {entry.type === 'stock_in_purchase'
                          ? 'Intrare marfa'
                          : entry.type === 'stock_in_return' || entry.type === 'stock_in_return_functional'
                          ? 'Retur functional'
                          : entry.type === 'stock_in_return_defect' || entry.type === 'stock_in_return_nonfunctional'
                          ? 'Retur nefunctional'
                          : 'Neridicat'}
                      </span>
                    </td>
                      <td style={tdStyle}>
                        <button
                          type="button"
                          onClick={() => handleDeleteEntry(entry.originalIndex ?? index)}
                          style={deleteButtonStyle}
                          title="Sterge inregistrarea"
                        >
                          X
                        </button>
                      </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

function formatTime(dateString) {
  if (!dateString) {
    return '-';
  }

  return new Date(dateString).toLocaleTimeString('ro-RO', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

function formatDateOnly(dateString) {
  if (!dateString) {
    return '-';
  }

  return new Date(dateString).toLocaleDateString('ro-RO', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}

function getTypeBadgeStyle(type) {
  const baseStyle = {
    display: 'inline-block',
    padding: '6px 10px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: '700'
  };

  if (type === 'stock_in_purchase') {
    return { ...baseStyle, background: '#dbeafe', color: '#1d4ed8' };
  }

  if (type === 'stock_in_return' || type === 'stock_in_return_functional') {
    return { ...baseStyle, background: '#dcfce7', color: '#166534' };
  }

  if (type === 'stock_in_return_defect' || type === 'stock_in_return_nonfunctional') {
    return { ...baseStyle, background: '#fee2e2', color: '#991b1b' };
  }

  return { ...baseStyle, background: '#fef3c7', color: '#92400e' };
}

const pageStyle = {
  maxWidth: '1500px',
  margin: '0 auto'
};

const titleStyle = {
  marginBottom: '8px',
  fontSize: '32px',
  color: '#111827'
};

const subtitleStyle = {
  marginTop: 0,
  marginBottom: '20px',
  color: '#4b5563'
};

const cardStyle = {
  background: '#ffffff',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  marginBottom: '20px'
};

const filtersGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '16px',
  alignItems: 'end'
};

const sectionTitleStyle = {
  marginTop: 0,
  marginBottom: '16px',
  color: '#111827'
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: '600',
  color: '#111827'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  fontSize: '15px',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  boxSizing: 'border-box'
};

const buttonGroupStyle = {
  display: 'flex',
  gap: '10px',
  alignItems: 'end',
  flexWrap: 'wrap'
};

const buttonStyle = {
  background: '#2563eb',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 18px',
  fontWeight: '700',
  cursor: 'pointer'
};

const secondaryButtonStyle = {
  background: '#6b7280',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 18px',
  fontWeight: '700',
  cursor: 'pointer'
};

const infoStyle = {
  background: '#e0f2fe',
  color: '#075985',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '600'
};

const errorStyle = {
  background: '#fee2e2',
  color: '#991b1b',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '600'
};

const tableWrapStyle = {
  overflowX: 'auto'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  minWidth: '1000px'
};

const thStyle = {
  textAlign: 'left',
  padding: '12px',
  background: '#f3f4f6',
  borderBottom: '1px solid #e5e7eb',
  color: '#111827',
  fontSize: '14px',
  whiteSpace: 'nowrap'
};

const tdStyle = {
  padding: '12px',
  borderBottom: '1px solid #e5e7eb',
  fontSize: '14px',
  color: '#111827',
  whiteSpace: 'nowrap'
};

const deleteButtonStyle = {
  background: '#dc2626',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  padding: '6px 10px',
  cursor: 'pointer',
  fontWeight: 700
};

export default StockHistory;
